import { useEffect, useState } from "react";
import api from "@/lib/api";
import { TrendingUp, TrendingDown, Minus, Fuel } from "lucide-react";

export default function FuelDeltaTicker() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    Promise.all([
      api.get("/fuel-prices"),
      api.get("/fuel-prices/history?days=2"),
    ]).then(([fpR, histR]) => {
      const fp = fpR.data;
      const hist = histR.data || [];
      // Find yesterday's row (second-to-last with a valid value)
      const today = new Date().toISOString().slice(0, 10);
      const yest = hist.filter((h) => h.date !== today).pop();
      if (!fp || !yest) return;
      const list = ["petrol", "diesel", "cng", "lpg"].map((k) => {
        const cur = fp[k]; const prev = yest[k];
        if (cur == null || prev == null) return null;
        const label = k === "petrol" ? "पेट्रोल" : k === "diesel" ? "डीज़ल" : k === "cng" ? "CNG" : "LPG";
        return { key: k, label, cur, prev, delta: Number((cur - prev).toFixed(2)) };
      }).filter(Boolean);
      setItems(list);
    }).catch(() => {});
  }, []);

  if (items.length === 0) return null;
  const doubled = [...items, ...items];
  return (
    <div className="bg-gradient-to-r from-amber-500 via-orange-500 to-amber-500 text-[#0F172A] overflow-hidden" data-testid="fuel-delta-ticker">
      <div className="max-w-7xl mx-auto px-4 py-1 flex items-center gap-4">
        <span className="shrink-0 bg-[#0F172A] text-amber-300 text-[10px] font-black uppercase tracking-widest px-2 py-0.5 rounded flex items-center gap-1">
          <Fuel className="w-3 h-3"/>ईंधन Δ
        </span>
        <div className="overflow-hidden flex-1">
          <div className="marquee-track text-xs font-bold">
            {doubled.map((it, i) => {
              const Icon = it.delta > 0 ? TrendingUp : it.delta < 0 ? TrendingDown : Minus;
              const cls = it.delta > 0 ? "text-red-700" : it.delta < 0 ? "text-emerald-800" : "text-slate-700";
              const sign = it.delta > 0 ? "+" : "";
              return (
                <span key={`${it.key}-${i}`} className="mr-8 inline-flex items-center gap-1.5">
                  <span>{it.label}</span>
                  <span className="font-black">₹{it.cur.toFixed(2)}</span>
                  <span className={`inline-flex items-center gap-0.5 ${cls} bg-white/70 rounded-full px-1.5 py-0.5 text-[10px]`}>
                    <Icon className="w-2.5 h-2.5"/>{sign}{it.delta}
                  </span>
                </span>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
